import { makeActionCreator } from 'utils'
import { LinkPage } from 'types'

export default {
	linksFetch: makeActionCreator<'LINKS_FETCH'>('LINKS_FETCH'),
	linksFetchSuccess: makeActionCreator<'LINKS_FETCH_SUCCESSS', LinkPage>('LINKS_FETCH_SUCCESSS'),
	redirectFetch: makeActionCreator<'REDIRECT_FETCH', string>('REDIRECT_FETCH'),
	redirectFetchFail: makeActionCreator<'REDIRECT_FETCH_FAIL'>('REDIRECT_FETCH_FAIL')
}
